import { render } from "./giros.vue?vue&type=template&id=b832a55e"
import script from "./giros.vue?vue&type=script&lang=js"
export * from "./giros.vue?vue&type=script&lang=js"

import "./giros.vue?vue&type=style&index=0&id=b832a55e&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__